import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import HeatMapOutlinedSvg from "@ant-design/icons-svg/es/asn/HeatMapOutlined";
import AntdIcon from "../components/AntdIcon";
var HeatMapOutlined = function HeatMapOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HeatMapOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  HeatMapOutlined.displayName = 'HeatMapOutlined';
}
export default /*#__PURE__*/React.forwardRef(HeatMapOutlined);